import { Point } from "../../../domain/drawing";

export interface IRelayoutable {
  isRelayoutableByHeight: boolean;
  isPositionFixed: boolean;
  move(difference: Point): void;
}

export function instanceOfIRelayoutable(instance: any): instance is IRelayoutable {
  return instance
    && (instance.isRelayoutableByHeight !== undefined)
    && (instance.isPositionFixed !== undefined)
    && (instance.move !== undefined);
}
